import { Link } from 'react-router-dom';
import { BookOpen, NotebookPen, ChartNoAxesCombined, ArrowRight, ChevronDown } from './Icons';
import { authURL, referralCode } from '../lib/navigation';

const steps = [
  {
    icon: BookOpen,
    title: '智能评测，发现强弱项',
    text: '通过首次作答积累证据，结合题型与科学、历史等内容主题，看清你的表现差异。',
  },
  {
    icon: NotebookPen,
    title: '针对加强，读懂每一次错误',
    text: '针对需要突破的部分选题；交卷后查看句意、考点、题目分析与易错提醒，理解答案背后的原因。',
  },
  {
    icon: ChartNoAxesCombined,
    title: '新题检验，看见能力变化',
    text: '通过同类新题与计时模拟观察训练效果，持续更新能力画像，安排下一轮练习。',
  },
];
export function LearningGuide() {
  return (
    <>
      <section className="visitor-guide" id="how-it-works" aria-labelledby="guide-title">
        <div className="section-heading">
          <div>
            <span className="eyebrow">SMALL STEPS, REAL PROGRESS</span>
            <h2 id="guide-title">让每一次练习，都有下一步。</h2>
          </div>
          <Link className="editorial-link" to="/practice">
            翻开练习目录 <ArrowRight size={18} />
          </Link>
        </div>
        <div className="visitor-steps">
          {steps.map(({ icon: Icon, title, text }, i) => (
            <article key={title}>
              <div className="step-marker">
                <span>0{i + 1}</span>
                <Icon size={29} weight="duotone" />
              </div>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </section>
      <section className="visitor-questions" aria-labelledby="visitor-questions-title">
        <div>
          <span className="eyebrow">BEFORE YOUR FIRST CHAPTER</span>
          <h2 id="visitor-questions-title">
            开始之前，
            <br />
            你可能想知道。
          </h2>
          <Link className="button primary" to={authURL('register', '/practice', referralCode())}>
            开启免费体验 <ArrowRight size={18} />
          </Link>
          <p>
            <Link className="editorial-link" to="/help">
              更多常见问题 <ArrowRight size={17} />
            </Link>
          </p>
        </div>
        <div className="learning-faq">
          <details>
            <summary>
              这里可以练习哪些内容？
              <ChevronDown size={19} aria-hidden="true" />
            </summary>
            <p>
              题库按 B2 First for Schools 青少年版与 B2 First
              标准版组织，包含阅读与英语运用、听力、写作和口语。当前可练习的版本和题组以目录中的已发布内容为准。
            </p>
          </details>
          <details>
            <summary>
              免费体验怎么开始？
              <ChevronDown size={19} aria-hidden="true" />
            </summary>
            <p>
              注册后获得连续 24
              小时体验。登录后可以开始练习、保存作答并查看学习记录。后续可在进阶会员页面查看实际开放的计划。
            </p>
          </details>
          <details>
            <summary>
              什么时候可以看到答案和评分？
              <ChevronDown size={19} aria-hidden="true" />
            </summary>
            <p>
              交卷后开放客观题评分与解析。写作和口语按题目量表由教师批改，完成后在原练习和学习记录中查看结果。
            </p>
          </details>
          <details>
            <summary>
              练习分数就是考试成绩吗？
              <ChevronDown size={19} aria-hidden="true" />
            </summary>
            <p>
              这里展示平台原始得分和学习表现。当前原创流程样题尚未进行考试等值校准，成绩不作为官方考试分数。
            </p>
          </details>
        </div>
      </section>
    </>
  );
}
